export const orderButtonState = {
  ready: "ready",
  loading: "loading",
  ordered: "ordered",
};
